export const SubscriptionType = {
	TeamTier2022_1: "TEAM_TIER_2022_1",
	IndividualTier2022_1: "INDIVIDUAL_TIER_2022_1",
	PlayerTier2022_1: "PLAYER_TIER_2022_1",
	ProTier2022_1: "PRO_TIER_2022_1",
};
